export default "__VITE_ASSET__uDgqjMnf__"